import React, { createContext, useContext, useState, useCallback } from 'react';

type TradeSource = 'all' | 'autonomous' | 'manual';

interface TradeSourceContextType {
  tradeSource: TradeSource;
  setTradeSource: (value: TradeSource) => void;
  tradeSourceParam: TradeSource;
  /** @deprecated Use tradeSource instead */
  showManualTrading: boolean;
  /** @deprecated Use setTradeSource instead */
  setShowManualTrading: (value: boolean) => void;
}

const ManualTradingContext = createContext<TradeSourceContextType>({
  tradeSource: 'all',
  setTradeSource: () => {},
  tradeSourceParam: 'all',
  showManualTrading: false,
  setShowManualTrading: () => {},
});

export const useManualTrading = () => useContext(ManualTradingContext);

export const ManualTradingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Trade source filter UI was removed — always default to 'all'
  // Clear any stale localStorage from the old filter
  const [tradeSource, setTradeSourceState] = useState<TradeSource>(() => {
    try {
      localStorage.removeItem('tradeSource');
      localStorage.removeItem('showManualTrading');
    } catch { /* ignore */ }
    return 'all';
  });

  const setTradeSource = useCallback((value: TradeSource) => {
    setTradeSourceState(value);
    try {
      localStorage.setItem('tradeSource', value);
    } catch { /* ignore */ }
  }, []);

  // Backwards-compatible shim
  const setShowManualTrading = useCallback((value: boolean) => {
    setTradeSource(value ? 'manual' : 'all');
  }, [setTradeSource]);

  return (
    <ManualTradingContext.Provider value={{
      tradeSource,
      setTradeSource,
      tradeSourceParam: tradeSource,
      showManualTrading: tradeSource === 'manual',
      setShowManualTrading,
    }}>
      {children}
    </ManualTradingContext.Provider>
  );
};
